import { apiFetchJson } from './api.ts';

/** The names of the feature flags switched on for the signed-in user. */
export async function fetchMyFeatureFlags(): Promise<string[]> {
  const { enabled } = await apiFetchJson<{ enabled: string[] }>(
    '/users/me/feature-flags',
  );

  return enabled;
}
